import { isArray } from 'lodash';

import { isStringEmptyOrNullOrUndefined } from 'utils/genericUtils';

export function formatValue(
  value: string | number | string[] | null,
  emptyMessage: string,
): string {
  if (isStringEmptyOrNullOrUndefined(value)) {
    return emptyMessage;
  } else if (isArray(value)) {
    return value.join('\n');
  }
  return value.toString();
}
